"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageDatasheetProvenanceSchema = exports.SeriesDatasheetBasis = exports.DatasheetProvenanceKind = void 0;
exports.currentDatasheetProvenance = currentDatasheetProvenance;
const z = require("zod");
var DatasheetProvenanceKind;
(function (DatasheetProvenanceKind) {
    DatasheetProvenanceKind["SharedCatalogueDocument"] = "shared_catalogue_document";
    DatasheetProvenanceKind["Series"] = "series";
})(DatasheetProvenanceKind || (exports.DatasheetProvenanceKind = DatasheetProvenanceKind = {}));
var SeriesDatasheetBasis;
(function (SeriesDatasheetBasis) {
    SeriesDatasheetBasis["MpnStem"] = "mpn_stem";
    SeriesDatasheetBasis["PackageFamily"] = "package_family";
})(SeriesDatasheetBasis || (exports.SeriesDatasheetBasis = SeriesDatasheetBasis = {}));
exports.PackageDatasheetProvenanceSchema = z.object({
    kind: z.nativeEnum(DatasheetProvenanceKind),
    fileId: z.string(),
    seriesBasis: z.nativeEnum(SeriesDatasheetBasis).optional(),
    sourcePackageId: z.string().optional(),
    sourceManufacturerPartNumber: z.string().optional(),
    matchedUrl: z.string().optional(),
});
function currentDatasheetProvenance(provenance, currentFileId) {
    return provenance !== undefined && provenance.fileId === currentFileId ? provenance : undefined;
}
//# sourceMappingURL=package-datasheet-provenance.js.map